module.exports = __webpack_public_path__ + "static/img/zhxkfpq.3194be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhxkfpq.png
// module id = uM44
// module chunks = 1